import {openDB, deleteDB, wrap, unwrap} from "idb";
const dbname = 'history';
const dbversion = 1;
import CloudSaveManager from "../managers/cloud-save-manager";

export default {
    async getDb() {
        const db = await openDB(dbname, dbversion, {
            upgrade(db) {
                // Create db if not exists
                const store = db.createObjectStore(dbname, {
                    keyPath: "id", // The 'id' property of the object will be the key.
                    autoIncrement: true, // If it isn't explicitly set, create a value by auto incrementing.
                });
                store.createIndex("date", "date");
            },
            blocked() {
                // Called if there are older versions of the database open on the origin, so this version cannot open. This is similar to the blocked event in plain IndexedDB.
                console.error("History db blocked");
            },
            blocking() {
                // Called if this connection is blocking a future version of the database from opening. This is similar to the versionchange event in plain IndexedDB.
                console.error("History db blocking");
            },
            terminated() {
                // Called if the browser abnormally terminates the connection, but not on regular closures like calling db.close(). This is similar to the close event in plain IndexedDB.
                console.error("History db terminated");
            },
        });
        return db;
    },

    async store(data) {
        const db = await this.getDb();
        const now = Date.now();
        await db.add(dbname, {
            date: now,
            body: data
        });
        CloudSaveManager.saveCalc(data, now);
    },

    async getAll() {
        const db = await this.getDb();
        const items = await db.getAllFromIndex(dbname, 'date');
        return items.reverse();
    },

    async delete(id) {
        const db = await this.getDb();
        await db.delete(dbname, id);
    },
};
